import React from "react";
import ActiveMissions from "./ActiveMissions";
import { useTranslation } from "react-i18next";
import Crumbs from "components/crumbs/Crumbs";
import MissionHeader from "modules/pvs_activities/components/mission/MissionHeader";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { USER_ROLES } from "constants";
import { ARCHIVED_ACCESS_ROLES } from "modules/pvs_activities/constants";

const MissionWorkspace = () => {
  const authData = useSelector(s => s.auth.data);
  const { t } = useTranslation();
  const crumbs = [
    {
      path: "/portal/",
      label: t("-1", "Home"),
      active: false,
    },
    {
      path: "/portal/mission-cc",
      label: t("-1", "Mission Control Center"),
      active: true,
    },
  ];

  return (
    <div className="container my-2">
      <Crumbs crumbs={crumbs} />
      <MissionHeader isControlCenter={true} />
      {
        (USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) || USER_ROLES.cbd_staff.includes(parseInt(authData?.role_id)) ||
          USER_ROLES.it_admin.includes(parseInt(authData?.role_id))) &&
        <div className="my-1">
          <div className="card card-woah border border-secondary mb-2 shadow rounded-0">
            <div className="pt-3 px-4">
              <i class="fa-solid fa-star text-primary me-2 "></i>
              <span
                className="pvs-title fw-bold fs-2 lh-1"
              >
                {t("-1", "Missions")}
              </span>
            </div>
            <div className="card-body p-4">
              <div className="row justify-content-start">
                <>
                  {/* <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/mission-management/create/?return=/portal/mission-cc"
                      className="d-block text-center btn-menu-light-blue-left btn-menu-dark-blue-color my-2 corner-rounded fw-bold py-10 px-10 w-100 shadow-sm"
                    >
                      <span className="text-uppercase">{t("262", "ADD NEW MISSION").toUpperCase()} - Stage 1</span>
                    </Link>
                  </div> */}
                  {/* <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/mission-management/?return=/portal/mission-cc"
                      className="d-block text-center btn-menu-grey-left-1 my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span className="text-uppercase">{t("2885", "MANAGE MY MISSIONS").toUpperCase()} - Stage 1</span>
                    </Link>
                  </div> */}
                  <div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/mission-request/?return=/portal/mission-cc"
                      className="d-block text-center btn-menu-light-orange-left btn-menu-dark-orange-color my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span>{t("-1", "Add New Mission Request").toUpperCase()}</span>
                    </Link>
                  </div>
                  {authData?.role_id && ARCHIVED_ACCESS_ROLES.includes(authData?.role_id) && (<div className="col-md-4 col-sm-6 col-12">
                    <Link
                      to="/portal/archive-mission/?return=/portal/mission-cc"
                      className="d-block text-center btn-menu-grey-left-1 my-2 fw-bold corner-rounded py-10 px-10 w-100 shadow-sm"
                    >
                      <span>{t("-1", "Archived Missions").toUpperCase()}</span>
                    </Link>
                  </div>)}
                </>
              </div>
            </div>
          </div>
        </div>
      }
      <ActiveMissions />
    </div>
  );
};
export default MissionWorkspace;
